
/**
 * Initializes phone number masking for input fields.
 * 
 * This function applies a phone number mask in the format (000) 000-0000
 * to elements with the class 'search-input' and the element with the ID 'phone-number'.
 */
export function initPhoneMasking() {
    $('.search-input').mask('(000) 000-0000');
    $('#phone-number').mask('(000) 000-0000');
  }